



















































































import { Prop } from 'vue-property-decorator';
import HuntingLicenseOrderForm from '@/modules/HuntingLicenses/LicenseOrder/Form.vue';
import Component, { mixins } from 'vue-class-component';
import { AxiosPromise } from 'axios';
import { HUNTING_LICENSE_ORDERS } from '@/common/api';
import UseBackend from '@/core/mixins/use-backend';
import StatusChip from '@/shared_components/StatusChip.vue';
import { Goal, statusApplication } from '@/common/constants';
import PaymentForm from '@/modules/HuntingLicenses/LicenseOrder/PaymentForm.vue';
import ModalRejectOrderAttachments from '@/shared_components/ModalRejectOrderAttachments.vue';
import HuntingLicenseForm from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseForm.vue';
import HuntingLicense from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseComponent.vue';
import HuntingLicenseComponent from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseComponent.vue';
import HuntingLicenseOrderStepper from '@/modules/HuntingLicenses/LicenseOrder/ShowWrapper.vue';
import HuntingLicenseOrderCharges from '@/modules/HuntingLicenses/LicenseOrder/HuntingLicenseOrderCharges.vue';

// eslint-disable-next-line no-use-before-define
@Component<LicenseOrderCopyShow>({
  components: {
    HuntingLicenseOrderCharges,
    HuntingLicense,
    HuntingLicenseOrderForm,
    HuntingLicenseComponent,
    StatusChip,
    ModalRejectOrderAttachments,
    HuntingLicenseForm,
    PaymentForm,
    HuntingLicenseOrderStepper,
  },
  data() {
    return { GOALS: Goal };
  },
})
export default class LicenseOrderCopyShow extends mixins(UseBackend) {
  @Prop({
    type: String,
    required: true,
  })
  orderId!: string;

  referrer: any = null;

  modalVisibilityReject: boolean = false;

  value: null | Orders.HuntingLicenseOrderCopy = null;

  statusApplication = statusApplication;

  modalVisibilityIssue: boolean = false;

  get isCompleted(): boolean {
    return (
      this.value !== null &&
      this.value.huntingLicense !== null &&
      this.value.statusApplicationId === statusApplication.SERVICE_PROVIDE.id
    );
  }

  get canBeTaken(): boolean {
    if (this.value?.userId === this.$currentUser.id) {
      return false;
    }
    return !([
      statusApplication.CANCEL.id,
      statusApplication.DENIED.id,
      statusApplication.SERVICE_PROVIDE.id,
    ] as Array<any>).includes(this.value?.statusApplicationId);
  }

  get doesNotHaveIssue(): boolean {
    return this.value !== null && this.value?.huntingLicense === null;
  }

  get personFio(): string {
    return [this.value?.lastname, this.value?.firstname, this.value?.middlename]
      .filter((s) => s)
      .join(' ');
  }

  async mounted(): Promise<void> {
    await this.refresh();
  }

  async refresh() {
    const request = () =>
      this.$http({
        ...HUNTING_LICENSE_ORDERS.GET(+this.orderId),
      }) as AxiosPromise<Orders.HuntingLicenseOrderCopy>;
    ({ data: this.value } = await this.makeRequest(request));
  }

  toList() {
    if (
      this.referrer !== null &&
      ['hunting-licenses-order-copy-list'].includes(this.referrer.name)
    ) {
      this.$router.push(this.referrer);
      return;
    }

    this.$router.push({ name: 'hunting-licenses-order-copy-list' });
  }

  // eslint-disable-next-line class-methods-use-this
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.referrer = from;
    });
  }

  async takeToWork() {
    const endpoint = HUNTING_LICENSE_ORDERS.TAKE_TO_WORK(+this.orderId);
    ({ data: this.value } = await this.makeRequest(() => this.$http(endpoint)));
  }

  async issueLicense(data) {
    const rejectOrderId = +this.orderId;
    const endpoint = HUNTING_LICENSE_ORDERS.ISSUE_LICENSE(rejectOrderId);
    await this.makeRequest(() => this.$http({ ...endpoint, data }));
    this.modalVisibilityIssue = false;
    await this.refresh();
  }

  async rejectOrder(reject) {
    const rejectOrderId = +this.orderId;
    const endpoint = HUNTING_LICENSE_ORDERS.REJECT(rejectOrderId);
    await this.makeRequest(() => this.$http({ ...endpoint, data: reject }));
    this.modalVisibilityReject = false;
    await this.refresh();
  }

  beforeDestroy(): void {
    this.modalVisibilityIssue = false;
    this.modalVisibilityReject = false;
  }
}
